import {
  Col,
  Row,
  Table,
  Tag,
  Card,
  Button,
  message,
  Spin,
  Select,
  Tooltip,
  Space,
  Badge,
} from "antd";
import Search from "antd/es/input/Search";
import React, { useEffect, useState } from "react";
import {
  FormOutlined,
  CloseCircleOutlined,
  CheckCircleOutlined,
  CommentOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import MotionHoc from "../../../utils/MotionHoc";
import { POST_MAIN_PAYMENT, HEADERS_EXPORT_BEN } from "../../API/apiUrls";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp, faArrowDown } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import DateCustom from "../../../hook/DateCustom";
import dayjs from "dayjs";
import CurrencyFormat from "../../../hook/CurrencyFormat";
import ClearPayment from "./modal/ClearPayment";

const Main = () => {
  // ============== HOOKS ==============
  const [convertDateThai, convertDateThaiShort] = DateCustom();
  const [
    currencyFormat,
    currencyFormatComma,
    currencyFormatPoint,
    currencyFormatNoPoint,
  ] = CurrencyFormat();

  // ============== LOCAL STORAGE ==============
  const ROLE_ID = localStorage.getItem("ROLE_ID");
  const userId = parseInt(localStorage.getItem("USER_ID"));

  // ============== STATES ==============
  const [isModal, setIsModal] = useState(false);
  const [arrayTable, setArrayTable] = useState([]);
  const [dataArr, setDataArr] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dataRecord, setDataRecord] = useState(null);
  const [tableLength, setTableLength] = useState(0);
  const [statusId, setStatusId] = useState(0);

  const { Option } = Select;

  // ============== LOAD DATA ==============
  useEffect(() => {
    loadData();
  }, [statusId]);

  const loadData = async () => {
    setLoading(true);

    const payload = {
      userId: userId,
      clearStatus: statusId,
    };

    console.log("Load data payload:", payload);

    try {
      const response = await axios.post(POST_MAIN_PAYMENT, payload, {
        headers: HEADERS_EXPORT_BEN,
      });

      if (response.data && Array.isArray(response.data)) {
        console.log("API Response:", response.data);
        processData(response.data);
      } else {
        setArrayTable([]);
        setDataArr([]);
        message.warning("ไม่พบข้อมูล");
      }
    } catch (error) {
      console.error("Error loading data:", error);
      message.error(`เกิดข้อผิดพลาด: ${error.message}`);
      setArrayTable([]);
      setDataArr([]);
    } finally {
      setLoading(false);
    }
  };

  // ============== PROCESS DATA ==============
  const processData = (rawData) => {
    if (!Array.isArray(rawData) || rawData.length === 0) {
      setArrayTable([]);
      setDataArr([]);
      setTableLength(0);
      return;
    }

    // ✅ กรองข้อมูลตาม Permission
    const filteredData = rawData.filter((item) => {
      const checkDOCNO = item.DOCNO;
      const isOwner = item.userId === userId;
      const billType = item.advaneType === 1;
      return isOwner && billType && checkDOCNO;
    });

    // ✅ เรียงข้อมูลตามวันที่ล่าสุด
    filteredData.sort(
      (a, b) => dayjs(b.payamtDate).valueOf() - dayjs(a.payamtDate).valueOf(),
    );

    setDataArr(filteredData);
    setArrayTable(filteredData);
    setTableLength(filteredData.length);
    console.log("Processed data:", filteredData);
  };

  // ============== SEARCH FUNCTIONS ==============
  const search = (event) => {
    console.log("Search query:", event.target.value);
    const trimmed = event.target.value.trim();
    onSearch(trimmed);
  };

  const onSearch = (value) => {
    if (!value) {
      setArrayTable(dataArr);
      setTableLength(dataArr.length);
      return;
    }
    const result = dataArr.filter(
      (item) =>
        item.TMBILL?.toLowerCase().includes(value.toLowerCase()) ||
        item.ALL_CONTNO?.some((obj) =>
          obj.CONTNO?.toLowerCase().includes(value.toLowerCase()),
        ),
    );

    setArrayTable(result);
    setTableLength(result.length);
  };

  // ============== UPDATE DATA ==============
  const handleUpdateData = () => {
    console.log("📥 Callback - Reloading data");
    loadData();
  };

  // ============== RENDER FUNCTIONS ==============
  const renderDate = (date, status) => {
    if (!date) {
      return "-";
    }

    const recordDate = dayjs(date);
    const today = dayjs().startOf("day");
    const daysDifference = today.diff(recordDate, "day");

    let color = "blue";
    if (status === 1) color = "green";
    else if (status === 4) color = "orange";
    else if (daysDifference > 7 && status === 0) color = "red";

    const formattedDate = convertDateThaiShort(recordDate);

    return (
      <Tag color={color} style={{ textAlign: "center" }}>
        {formattedDate}
        {(status === 0 || status === null) && (
          <>
            <br />
            {daysDifference > 7 && "นาน"} {daysDifference} วัน
          </>
        )}
      </Tag>
    );
  };

  const renderContnoList = (record) => {
    if (!record.ALL_CONTNO || record.ALL_CONTNO.length === 0) {
      return "-";
    }

    return record.ALL_CONTNO.map((item, index) => (
      <strong key={index}>
        {item.CONTNO}
        {index < record.ALL_CONTNO.length - 1 && <br />}
      </strong>
    ));
  };

  const renderStatusWithdraw = (status) => {
    const statusMap = {
      0: { text: "รอดำเนินการ", color: "blue" },
      1: { text: "อนุมัติ", color: "green" },
      2: { text: "ไม่อนุมัติ", color: "red" },
      4: { text: "รออนุมัติ", color: "blue" },
    };

    const { text, color } = statusMap[status] || statusMap[0];

    return <Tag color={color}>{text}</Tag>;
  };

  const renderStatusClear = (status) => {
    const statusMap = {
      0: { text: "รอดำเนินการ", color: "blue" },
      4: { text: "รออนุมัติ", color: "orange" },
      1: { text: "เสร็จสิ้น", color: "green" },
      2: { text: "ไม่อนุมัติ", color: "green" },
    };

    const { text, color } = statusMap[status] || statusMap[0];

    return <Tag color={color}>{text}</Tag>;
  };

  const renderOpteionStatus = () => {
    return (
      <>
        <Option value={0}>
          <span style={{ marginRight: 8 }}>🕒</span>
          รอดำเนินการ
        </Option>
        <Option value={4}>
          <SyncOutlined style={{ color: "orange", marginRight: 8 }} />
          รออนุมัติ
        </Option>
        <Option value={1}>
          <CheckCircleOutlined style={{ color: "green", marginRight: 8 }} />
          อนุมัติ
        </Option>
        <Option value={2}>
          <CloseCircleOutlined style={{ color: "red", marginRight: 8 }} />
          ไม่อนุมัติ
        </Option>
      </>
    );
  };

  const renderTotalAmountWithdraw = (record) => {
    const amount = parseFloat(record.payamt) || 0;
    return (
      <div>
        <p style={{ color: "#1890ff", fontWeight: "500" }}>
          {currencyFormatPoint(amount)} บาท
        </p>
      </div>
    );
  };

  const renderTotalAmountClear = (record) => {
    // ✅ คำนวณยอดรวมที่เคลียร์จาก ALL_CONTNO
    let totalClear = 0;

    if (record.ALL_CONTNO && Array.isArray(record.ALL_CONTNO)) {
      record.ALL_CONTNO.forEach((item) => {
        if (item.PAY) {
          totalClear += parseFloat(item.PAY) || 0;
        }
      });
    }

    const totalWithdraw = parseFloat(record.payamt) || 0;

    if (totalClear === 0) {
      return <p>-</p>;
    }

    return (
      <p
        style={{
          color:
            totalClear === totalWithdraw
              ? "#000"
              : totalClear > totalWithdraw
                ? "green"
                : "red",
          fontWeight: "500",
        }}
      >
        <FontAwesomeIcon
          icon={
            totalClear < totalWithdraw
              ? faArrowDown
              : totalClear > totalWithdraw
                ? faArrowUp
                : null
          }
        />{" "}
        {currencyFormatPoint(totalClear)} บาท
        <br />
        {totalClear > totalWithdraw && (
          <span style={{ fontSize: "12px" }}>
            เบิกขาด {currencyFormatPoint(totalWithdraw - totalClear)} บาท
          </span>
        )}
        {totalClear < totalWithdraw && (
          <span style={{ fontSize: "12px" }}>
            เบิกเกิน {currencyFormatPoint(totalWithdraw - totalClear)} บาท
          </span>
        )}
      </p>
    );
  };

  const renderEventHandle = (record) => {
    return (
      <div style={{ margin: 0 }}>
        {record.approvalStatus === 1 &&
        (record.clearStatus === 0 || record.clearStatus === null) ? (
          <Button
            type="primary"
            style={{ boxShadow: "0 4px 3px" }}
            onClick={() => {
              setIsModal(true);
              setDataRecord(record);
            }}
          >
            <FormOutlined /> เคลียร์เงิน
          </Button>
        ) : record.clearStatus === 4 ? (
          <Button
            style={{
              boxShadow: "0 4px 3px",
              borderColor: "orange",
              color: "orange",
            }}
            onClick={() => {
              setIsModal(true);
              setDataRecord(record);
            }}
          >
            <FormOutlined /> แก้ไขการเคลียร์
          </Button>
        ) : null}
      </div>
    );
  };

  const onChangeSelectStatus = (value) => {
    setStatusId(value);
  };

  // ============== TABLE COLUMNS ==============
  const columns = [
    {
      title: "ลำดับ",
      dataIndex: "key",
      key: "key",
      align: "center",
      width: 50,
      render: (text, record, index) => index + 1,
    },
    {
      title: "เลขที่อ้างอิง",
      align: "center",
      render: (text, record) => (
        <strong style={{ color: "#1890ff" }}>{record.TMBILL}</strong>
      ),
    },
    {
      title: "เลขที่สัญญา",
      align: "center",

      render: (text, record) => renderContnoList(record),
    },
    {
      title: "ขอเบิกเมื่อ",
      align: "center",

      render: (record) => renderDate(record.payamtDate, record.approvalStatus),
    },
    {
      title: "จำนวนที่เบิก",
      align: "center",

      render: (record) => renderTotalAmountWithdraw(record),
    },
    {
      title: "อนุมัติเบิกเมื่อ",
      align: "center",

      render: (record) =>
        renderDate(record.approvalDate, record.approvalStatus),
    },
    {
      title: "สถานะเบิก",
      align: "center",

      render: (record) => renderStatusWithdraw(record.approvalStatus),
    },
    {
      title: "จำนวนที่เคลียร์",
      align: "center",

      render: (record) => renderTotalAmountClear(record),
    },
    {
      title: "เคลียร์เมื่อ",
      align: "center",

      render: (record) => renderDate(record.clearDate, record.clearStatus),
    },
    {
      title: "สถานะเคลียร์",
      align: "center",

      render: (record) => renderStatusClear(record.clearStatus),
    },
    {
      title: "หมายเหตุ",
      align: "center",
      width: 150,
      render: (record) => {
        if (!record.allNote || record.allNote.length === 0) {
          return "-";
        }

        const tooltipContent = (
          <div>
            {record.allNote.map((noteItem, index) => (
              <div key={noteItem.id || index} style={{ marginBottom: "8px" }}>
                <div>
                  <p strong style={{ color: "white" }}>
                    {noteItem.note}
                  </p>
                </div>
                <div>
                  <p style={{ color: "#d9d9d9", fontSize: "12px" }}>
                    โดย: {noteItem.USERNAME}
                  </p>
                </div>
                <div>
                  <p style={{ color: "#d9d9d9", fontSize: "12px" }}>
                    {dayjs(noteItem.CreatedAt).format("DD/MM/YYYY HH:mm")}
                  </p>
                </div>
              </div>
            ))}
          </div>
        );

        return (
          <Tooltip title={tooltipContent}>
            <Space>
              <CommentOutlined style={{ color: "#1890ff" }} />
              <Badge count={record.allNote.length} />
            </Space>
          </Tooltip>
        );
      },
    },

    (statusId === 0 || statusId === 4) && {
      title: "การจัดการ",
      align: "center",
      // fixed: "right",
      render: (record) => renderEventHandle(record),
    },
  ].filter(Boolean);

  return (
    <>
      <Card>
        <Spin spinning={loading} size="large" tip="กำลังโหลดข้อมูล...">
          <Row>
            {/* ============== SEARCH BAR ============== */}
            <Col span={24} style={{ textAlign: "end", marginBottom: "10px" }}>
              <Select
                placeholder="เลือกสถานะ"
                onChange={onChangeSelectStatus}
                value={statusId}
                style={{ marginRight: "10px" }}
                size="large"
              >
                {renderOpteionStatus()}
              </Select>

              <Search
                placeholder="ค้นหาเลขที่อ้างอิง / สัญญา"
                onChange={search}
                enterButton
                style={{ width: 280 }}
                size="large"
              />
            </Col>

            {/* ============== TABLE ============== */}
            <Col span={24}>
              <Table
                size="small"
                columns={columns}
                dataSource={arrayTable}
                scroll={{ x: 1200 }}
                loading={loading}
                bordered
                rowKey="key"
                footer={() => (
                  <p>
                    <strong>จำนวนรายการทั้งหมด: {tableLength} รายการ</strong>
                  </p>
                )}
                pagination={{
                  defaultPageSize: 20,
                  showSizeChanger: true,
                  showTotal: (total, range) =>
                    `แสดง ${range[0]}-${range[1]} จาก ${total} รายการ`,
                  pageSizeOptions: ["10", "20", "50", "100"],
                }}
              />
            </Col>
          </Row>
        </Spin>
      </Card>

      {/* ============== MODAL ============== */}
      {isModal && (
        <ClearPayment
          open={isModal}
          close={() => {
            setIsModal(false);
            setDataRecord(null);
          }}
          dataDefault={dataRecord}
          funcUpdateStatus={handleUpdateData}
        />
      )}
    </>
  );
};

const ClearAdvancePaymentEnforceAsset = MotionHoc(Main);
export default ClearAdvancePaymentEnforceAsset;
